/* eslint-disable react/jsx-props-no-spreading */

import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings } from '@styles/index';
import SubHeaderContent from './SubHeaderContent';

const SmallHeaderWrapper = styled.div`
  grid-column: span 24;
  background: var(--color-base-0);
  display: flex;
  border-radius: ${Spacings.SPACING_2B};
  position: fixed;
  width: 1136px;
  transition: all 400ms ease-in-out;
  justify-content: space-between;
  z-index: 2;
  background-color: var(--color-base-0);
  box-shadow: ${boxShadowGenerator()};
  top: ${({ scroll }) => (scroll ? Spacings.SPACING_18B : '-72px')};
  @media (max-width: 47.95em) {
    width: 100%;
    z-index: 2;
    left: 0;
    right: 0;
    top: inherit;
    margin: 0;
    bottom: ${({ scroll }) => (scroll ? '0px' : '-80px')};
  }
`;

const SubHeader = (props) => {
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop } = document.documentElement;
      if (scrollTop > 400 && !scroll) {
        setScroll(true);
      } else if (scrollTop < 400 && scroll) {
        setScroll(false);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scroll]);

  return (
    <SmallHeaderWrapper scroll={scroll}>
      <SubHeaderContent {...props} />
    </SmallHeaderWrapper>
  );
};

export default SubHeader;

SubHeader.propTypes = {
  courseUid: PropTypes.string.isRequired,
  goalUid: PropTypes.string.isRequired,
  handleEnroll: PropTypes.func.isRequired,
  isTestSeries: PropTypes.bool,
  dataAnalytics: PropTypes.string
};

SubHeader.defaultProps = {
  isTestSeries: false,
  dataAnalytics: ''
};
